module.exports = __webpack_public_path__ + "img/allProctoring.222e19f1.svg";